import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ChangesNotSavedComponent } from '.';
import { DialogContentComponent } from '../layout/dialog/dialog-content.component';

@Injectable()
export class ChangesNotSavedGuard {
    constructor(public dialog: MatDialog) {}
    async canDeactivate(component: ChangesNotSavedComponent): Promise<boolean> {
        let canContinueNavigation = false;

        if (component.isChanged() && !component.isSaved()) {
            const dialogRef = this.dialog.open(DialogContentComponent, {
                data: {
                    step: 'leave'
                }
            });

            const result = await dialogRef.afterClosed().toPromise();
            canContinueNavigation = result === true;
        } else canContinueNavigation = true;

        return canContinueNavigation;
    }
}
